import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ProjectCard } from "../components/ProjectCard";

const projects = [
  {
    title: "Doc's BBQ & Whiskey",
    tag: "Cadillac Eldorado · Signature build · Prescott, AZ",
    images: [
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_dave-wraps-studio/artifacts/gdsgdl1l_IMG_0845.webp",
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_dave-wraps-studio/artifacts/bjnjxtyu_IMG_0848.webp",
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_dave-wraps-studio/artifacts/njysukur_IMG_0854.webp",
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_dave-wraps-studio/artifacts/4x31jhik_IMG_0814.webp",
    ],
    span: "md:col-span-8 md:row-span-2",
    position: "center",
  },
  {
    title: "The Fat Frog Sports Grill",
    tag: "Custom hot rod fleet · Prescott, AZ",
    images: [
      "https://customer-assets.emergentagent.com/job_dave-wraps-studio/artifacts/hjqwh9mt_IMG_0790.webp",
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_dave-wraps-studio/artifacts/yoqx75nc_IMG_0796.webp",
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_dave-wraps-studio/artifacts/c29pxpid_IMG_0882.webp",
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_dave-wraps-studio/artifacts/tzp0y4ga_IMG_0720.webp",
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_dave-wraps-studio/artifacts/dzibwv80_IMG_0778.webp",
    ],
    span: "md:col-span-4 md:row-span-2",
    position: "center",
  },
  {
    title: "Findlay Toyota Prescott",
    tag: "America's 250th Anniversary Tundra wrap",
    images: [
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_dave-wraps-studio/artifacts/au6whybi_IMG_0443.webp",
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_dave-wraps-studio/artifacts/pjqla80l_IMG_0444.webp",
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_dave-wraps-studio/artifacts/qp5mts03_IMG_0445.webp",
    ],
    span: "md:col-span-4",
    position: "center",
  },
  {
    title: "PRYME Coatings",
    tag: "Box truck wrap · Prescott, AZ",
    images: [
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_dave-wraps-studio/artifacts/t1f97yvx_IMG_0465.webp",
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_dave-wraps-studio/artifacts/h93st1h1_IMG_0466.webp",
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_dave-wraps-studio/artifacts/6ghny1rz_IMG_0467.webp",
    ],
    span: "md:col-span-4",
    position: "center",
  },
  {
    title: "Southwest Expedited",
    tag: "Hauling Freedom · Peterbilt semi-truck",
    images: [
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_dave-wraps-studio/artifacts/vqvke081_IMG_0871.webp",
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_dave-wraps-studio/artifacts/vfikq0lt_IMG_0870.webp",
    ],
    span: "md:col-span-4",
    position: "center",
  },
  {
    title: "928 Wraps · Shop Truck",
    tag: "Full commercial wrap · Watson Lake, AZ",
    images: [
      "https://customer-assets.emergentagent.com/job_dave-wraps-studio/artifacts/sfmqpd3j_IMG_5167-scaled.webp",
    ],
    span: "md:col-span-4",
  },
  {
    title: "Yavapai Landscaping",
    tag: "Two-truck fleet · design build maintain",
    images: [
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_dave-wraps-studio/artifacts/k2g2crmk_IMG_0687.webp",
    ],
    span: "md:col-span-8",
    position: "center",
  },
  {
    title: "Ace Home Services",
    tag: "HVAC · Plumbing · Electrical Fleet",
    images: [
      "https://customer-assets.emergentagent.com/job_dave-wraps-studio/artifacts/lcb8vic6_IMG_0779-scaled.webp",
    ],
    span: "md:col-span-4",
  },
  {
    title: "Prescott Valley Police",
    tag: "Municipal fleet",
    images: [
      "https://customer-assets.emergentagent.com/job_dave-wraps-studio/artifacts/03l5jir3_PVPD_8.jpg",
    ],
    span: "md:col-span-4",
  },
  {
    title: "CertaPro Painters · Northern AZ",
    tag: "Sprinter van wrap",
    images: [
      "https://customer-assets.emergentagent.com/job_dave-wraps-studio/artifacts/exkov5t4_IMG_3345-scaled.webp",
    ],
    span: "md:col-span-4",
  },
  {
    title: "Prescott Epoxy Company",
    tag: "Box truck · Bold commercial wrap",
    images: [
      "https://customer-assets.emergentagent.com/job_dave-wraps-studio/artifacts/voknl8a0_Image-6-20-25-at-7.11%E2%80%AFPM.jpg",
    ],
    span: "md:col-span-12",
  },
];

export default function Portfolio() {
  return (
    <div data-testid="page-portfolio">
      <section className="pt-40 pb-16">
        <div className="wrap">
          <div className="eyebrow eyebrow-red">Selected work · 2019 → today</div>
          <h1 className="h-display text-6xl md:text-8xl uppercase mt-4 max-w-4xl">
            Real projects. <span className="italic font-normal">Real businesses.</span> Real results.
          </h1>
          <p className="mt-6 text-lg text-neutral-600 max-w-2xl">
            A rotating collection of local Arizona businesses we&apos;ve helped become impossible to ignore. Swipe or click any project to see more angles.
          </p>
        </div>
      </section>

      <section className="pb-32">
        <div className="wrap">
          <div className="grid md:grid-cols-12 auto-rows-[260px] gap-4 md:gap-6">
            {projects.map((p, i) => (
              <ProjectCard
                key={i}
                testId={`portfolio-${i}`}
                title={p.title}
                tag={p.tag}
                images={p.images}
                span={p.span}
                position={p.position}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="pb-32">
        <div className="wrap">
          <div className="border border-neutral-200 rounded-3xl p-10 md:p-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div>
              <div className="eyebrow eyebrow-red">Ready to be next?</div>
              <h3 className="h-display text-4xl md:text-5xl uppercase mt-3">Your business could be <span className="italic font-normal">here.</span></h3>
            </div>
            <Link to="/mockup" data-testid="portfolio-cta" className="btn-red">Get My FREE Mockup <ArrowRight size={16} /></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
